import {environment} from '../../../environments/environment';

export function appLog(...data: any): void {
  if (!environment.production) {
    console.log(...data);
  }
}
